import { createStyles, makeStyles } from '@mui/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: '20px',
      padding: '20px',
      gap: '20px'
    },
    selectContainer: {
      maxWidth: '400px',
      marginTop: '20px',
      marginBottom: '20px'
    },
    dateContainer: {
      width: '300px',
      marginLeft: '20px',
      marginBottom: '20px'
    },
    buttonsContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '20px',
      marginTop: '20px',
      minHeight: '68px'
    }
  })
)
